<template >
    <div class="container-fluid">
      
          <form v-on:submit.prevent="submit()">
          <div class="mt-4 mb-4">        
            <div class="">               
                <label for="inputCashBack" class="form-label"><strong>CLIENTE : <span class="cust "> {{ props.first_name }} {{ props.last_name }} </span> </strong></label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <div class="input-group-text ">€</div>
                    </div>
                        <input :disabled="disabled" v-focus  step="0.01"  required type="number" id="cb" class="form-control" v-model="cb" >                    
                </div>
                
                <div class="input-group mt-2">
                    <div class="input-group-prepend">
                        <div class="input-group-text ">NOTE</div>
                    </div>
                        <input :disabled="disabled" required  type="text" id="note" class="form-control" v-model="note" >                    
                </div>                                                              
                <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
            </div>
            
          </div>
          <button  :disabled="bt_spinner || disabled" class="btn btn-primary">
                     <i  class="fas fa-save mr-2" aria-hidden="true"></i>
                    REGISTRA
                    <span v-if="bt_spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  </button>
        </form>
    
    
    
    </div>
    </template>
    <script>
    
    import api                        from '@/api'
    import alertBox                   from '@/components/common/AlertBox.vue';
    import { mapGetters }             from 'vuex';
        
    export default {
      props:['props'] , 
      components: {alertBox},
      
     data () {
        return {
        
        cb          : 0,
        note        : '',
        bt_spinner  : false,
        disabled    : false,
        
        //option    : 0,
        msg : {
            title : '',
            body  : '',
            type  : 0
          }
    
    
        }
      },
      directives: 
        {
          focus: {
          
            inserted: function (el) {
              
              el.focus()
              }
               
           
          }
        },
      computed: {
        ...mapGetters(['company','storeId']) 
      },
    mounted()
    {
        
        
       
    },  
    created()
    {
     
        this.cb = this.props.cashback.toFixed(2)
        
    },
    methods : {
    
    async submit()
    {
        
      this.bt_spinner = true
      var sp   = {'sp'    :  'spUpdateCustomerCashBack'}      
      var data = {
                  'customerId'     : this.props.customerId, 
                  'new_cb'         : this.cb,
                  /*'old_cb'         : this.props.cashback,*/
                  'note'           : this.note,
                  'storeId'        : this.storeId
                 }
                
      var json  = Object.assign(data, sp)
      
      
      await api.post(json).then(res => {
        if(res.status==200)
          {

            this.disabled = true
            this.msg.title  = 'MODIFICA CASHBACK EFFETTUATA.'
            this.msg.body = ''
            this.msg.type   = 0

          }
          else if(res.status==500)
          {
          

            this.msg.title  = 'ATTENZIONE '
            this.msg.body = res.data
            this.msg.type   = 1

          } 
          else
          {
            

            this.msg.title  = 'ATTENZIONE '
            this.msg.body = res
            this.msg.type   = 1               
          } 
      }).catch(err => 
      {
        console.log(err.message)   
            this.msg.title  = err.message
            this.msg.type   = 1 
      }).finally(() => {
        this.bt_spinner = false
      });



    
        
        
    }
}
}
    </script>
    <style scoped>
    .cust{
        color:brown;
        font-size : 20px;
    }
    </style>
    